export default {"src":"/_next/static/media/liquidity-op.65a7eacc.gif","height":360,"width":360,"blurWidth":0,"blurHeight":0};